<template>
  <transition name="slide-x-transition" mode="out-in">
    <section class="teacher-account-settings" v-show="ready">
      <v-container class="header" fill-height>
        <v-row class="mb-2">
          <v-col cols="12">
            <h1 class="header-title optus-highlight optus-highlight--yellow">
              Help & Support &nbsp;
            </h1>
            <v-card class="my-4">
              <v-toolbar color="primary" flat dark>
                <v-toolbar-title>FAQs</v-toolbar-title>
              </v-toolbar>
            </v-card>
            <!-- <search class="mt-3" /> -->
            <faq class="mt-3" :faqs="faqs" />
            <v-card class="my-4">
              <v-toolbar color="primary" flat dark>
                <v-toolbar-title>Submit a query</v-toolbar-title>
              </v-toolbar>
            </v-card>
            <send-question class="mt-3" :questions="questions" />
          </v-col>
        </v-row>
      </v-container>
    </section>
  </transition>
</template>

<script>
//import Search from './Search'
import Faq from '@/modules/support/views/Faq'
import SendQuestion from '@/modules/support/views/SendQuestion'
import { mapState } from 'vuex'

export default {
  name: 'Support',
  components: {
    //Search,
    Faq,
    SendQuestion
  },
  data() {
    return {
      ready: false
    }
  },
  async mounted() {
    this.$store.state.loading = true
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  computed: {
    ...mapState(['lessonTerm']),
    questions() {
      return [
        {
          text: 'General',
          value: 'general'
        },
        {
          text: 'Class',
          value: 'class'
        },
        {
          text: `${this.capitalizeFirstLetter(this.lessonTerm)}`,
          value: 'workshop'
        },
        {
          text: 'View results and graphs',
          value: 'marks_graphs'
        }
      ]
    },
    faqs() {
      return [
        {
          title: 'General',
          type: 'general',
          items: [
            {
              question: `How do the ${this.lessonTerm}s work? What’s involved?`,
              answer: `Each ${this.lessonTerm}  follows an interactive format to demonstrate the key learning concepts. <br><br>Our ${this.lessonTerm}s start with a pre-quiz to test your knowledge before you begin. You will then work your way through the lesson material where you’ll find a variety of content and interactive activities to suit different learning styles. At the end you’ll test your knowledge again to see how far you’ve come!<br><br>What are you waiting for? Start a lesson to begin your learning! 
`
            },
            {
              question: `Is there a time limit on each ${this.lessonTerm}?`,
              answer: `There is no time limit on the ${this.lessonTerm}s. You have access to all lessons for an unlimited time.`
            },
            {
              question: `I don’t have time to finish the ${this.lessonTerm} in one go. Will my answers be saved?`,
              answer: `Your progress in the ${this.lessonTerm} will be saved and you can come back to where you left off at any time. `
            },
            {
              question: `I want to go back to a ${this.lessonTerm} I’ve already completed. How can I do that? `,
              answer: `Once you have completed the ${this.lessonTerm}, it will disappear from your ‘To Do List’ on My Dashboard, but you can still access all your ${this.lessonTerm}s from the '${this.lessonTerm}s' tab and start the ${this.lessonTerm} again. `
            },
            {
              question: `How can I see the ${this.lessonTerm}s that I have yet to complete? `,
              answer: `Your ‘To Do List’ on your dashboard shows all the ${this.lessonTerm}s that are available to you, that you haven’t already completed. You can also view all available ${this.lessonTerm}s from the ‘${this.lessonTerm}s’ tab in the main menu. `
            },
            {
              question: `Can I get a certificate showing I have completed a ${this.lessonTerm}?`,
              answer: `If you’ve completed a ${this.lessonTerm}, firstly great work for taking the time to improve your knowledge! Unfortunately at the moment we are unable to provide certificates for completed courses, but we hope the ${this.lessonTerm}s have improved your knowledge on the topic in ways you can implement. Pro tip: Make your own certificate and congratulate yourself!`
            },
            {
              question: 'How can I see my results? ',
              answer: `Unfortunately we don’t yet have a way for you to see your ${this.lessonTerm} results, but we’re working on it! `
            }
          ]
        },
        {
          title: 'Account Management ',
          type: 'account management',
          items: [
            {
              question: 'How can I update my personal details? ',
              answer:
                'You can update your details in the ‘Account Details’ tab. Here you can amend your name, email address and password. '
            },
            {
              question: 'How can I update my password?',
              answer:
                'You can update your password from the ‘Account Details’ tab.'
            },
            {
              question: 'How can I cancel my account?',
              answer:
                'We’re sorry to hear you wish to cancel your account. We hope you have found the program useful. <br><br>Submit a Support Query using the form below telling us you would like to cancel your account and we will action this for you right away.'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-account-settings {
}
</style>
